export const lazyLoadWhenInViewport = (getElement) =>
  new Promise((resolve) => {
    const observerOptions = {
      rootMargin: '200px',
    };

    const observer = new IntersectionObserver((entries, observerInstance) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          // As soon as one element is visible, resolve the promise and stop observing.
          observerInstance.disconnect();
          resolve();
          return;
        }
      }
    }, observerOptions);

    setTimeout(() => {
      const elements = getElement();
      if (!elements) {
        return;
      }

      if (typeof elements === 'object') {
        observer.observe(elements);
      } else if (elements.length) {
        for (const el of elements) {
          observer.observe(el);
        }
      }
    }, 0);
  });
